import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		defaultMessage: 'Settings',
		id: 'atlassian-navigation.plans.menu.admin-footer.settings',
		description:
			'Dropdown item title in the top bar navigation. Item navigates to the Plans settings page',
	},
});
